import React from "react";
import "../IVRSolutions/IVRSolutions.css";
import {
    FaCheckCircle,
    FaComments,
    FaRobot,
    FaChartLine,
    FaClock,
    FaHeartbeat,
    FaUniversity,
    FaCar,
    FaShoppingCart,
    FaGraduationCap,
    FaBuilding,
} from "react-icons/fa";
import centerImage from "../../pages/IVRSolutions/assets/ss.png";
import whatsappFlowImage from "./assets/whatsapp-flow.png";

const WhatsAppApi = () => {

return (
<>
    <div className="services-banner">
        <div className="overlay"></div>
        <div className="content">
            <div className="line"></div>
            <div>
                <h1>WhatsApp API & chatbot</h1>
                <p>
                    <b className="bold">WhatsApp API & Chatbot</b> is a effective conversation answer that lets in
                    corporations to connect with
                    their clients instantly, <br /> automate conversations, and streamline client engagement. With the help of
                    the WhatsApp Business API, agencies can<br /> send notifications, promotional messages, updates, and
                    provide actual-time help at scale.
                </p>
                <p>
                    <span className="home">Home</span> → Service → WhatsApp API & chatbot
                </p>
            </div>
        </div>
    </div>
    <section className="ivr-section">
        <div className="ivr-container">
            <section className="about-sectionvv">
                <div className="about-containervv">
                    <div className="about-contentvv">
                        <span className="about-tagvv">WhatsApp API & Chatbot</span>
                        <h1>What is WhatsApp API & Chatbot?</h1>
                        <p className="about-descvv">
                            A WhatsApp enterprise chatbot is an smart automation tool that interacts with clients,
                            solutions their queries, and publications them through services or products with out human
                            intervention. Combined with WhatsApp API ship message capability, organizations can supply
                            personalized messages, alerts, and reminders instantly.
                        </p>
                        <div className="about-featuresvv">
                            <div className="feature-rightvv">
                                <p>
                                    <FaCheckCircle /> Automate customer replies with WhatsApp business chatbot
                                </p>
                                <p>
                                    <FaCheckCircle /> Send instant updates using <b className="bold">WhatsApp API send message</b>
                                </p>
                                <p>
                                    <FaCheckCircle /> Provide 24/7 customer support without human effort
                                </p>
                                <p>
                                    <FaCheckCircle /> Engage customers with personalized messaging
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                                <section className="services-bb">
                    <div className="container-bb">
                        <h5 className="subheading-bb"> WhatsApp API & Chatbot Flow</h5>
                        <h2 className="heading-bb">
                            WhatsApp API & Chatbot Solution Flow
                        </h2>

                                        <div style={{ marginTop: "24px" }}>
                                            <img
                                                src={whatsappFlowImage}
                                                alt="WhatsApp API and chatbot flow diagram"
                                                style={{ width: "100%", maxWidth: "1100px", height: "auto", display: "block", margin: "0 auto" }}
                                            />
                        </div>
                    </div>
                </section>
                <section className="why-section">
                    <div className="why-left">
                        <span className="tags">Needs</span>

                        <h1>Why Your Business Needs WhatsApp API & Chatbot</h1>
                        <p>
                            Modern customers count on short responses, personalised communique, and 24/7 availability.
                            This is precisely in which WhatsApp API & Chatbot solutions emerge as critical.
                            With the <b className="bold">WhatsApp Business API</b>, businesses can automate purchaser
                            interactions at the same
                            time as preserving a human-like verbal exchange revel in. 

                        </p>
                    </div>
                    <br />
                    <div className="why-container">
                        <div className="why-right">
                            <div className="card">
                                <p>
                                    <FaComments className="why-icon" /> Instant communication with clients using <b>WhatsApp API send message</b>
                                </p>
                            </div>

                            <div className="card">
                                <p>
                                    <FaRobot className="why-icon" /> Automated responses through WhatsApp commercial enterprise chatbot
                                </p>
                            </div>

                            <div className="card">
                                <p>
                                    <FaChartLine className="why-icon" /> Increased conversions and lead era
                                </p>
                            </div>

                            <div className="card">
                                <p>
                                    <FaClock className="why-icon" /> 24/7 availability without additional manpower
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="why-sectionz">
                    <h2>Key Features of WhatsApp API & Chatbot</h2>
                    <div className="why-containerz">
                        <div className="why-gridz">
                            <div className="why-colz">
                                <p>
                                    <FaCheckCircle />
                                    Automated Messaging System
                                </p>
                                <p>
                                    <FaCheckCircle /> AI-Powered WhatsApp business chatbot
                                </p>
                                <p>
                                    <FaCheckCircle /> Bulk Messaging Capabilities
                                </p>
                            </div>
                            <div className="why-colz">
                                <p>
                                    <FaCheckCircle /> CRM & System Integration
                                </p>
                                <p>
                                    <FaCheckCircle /> Multi-Agent Support
                                </p>
                                <p>
                                    <FaCheckCircle /> Real-Time Analytics
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="industriesss">
                    <h2>Industries We Serve</h2>
                    <p>
                        Our WhatsApp API & Chatbot solutions are designed to satisfy the wishes of more than one
                        industries. Whether you are a startup or an organization, our services help you scale
                        efficiently.

                    </p>
                    <br />
                    <div className="industries-containerss">
                        <div className="industries-rightss">
                            <div className="cardss"><FaHeartbeat className="industry-icon" /> Healthcare</div>
                            <div className="cardss"><FaUniversity className="industry-icon" /> Finance & Banking</div>
                            <div className="cardss"><FaCar className="industry-icon" /> Automobile</div>
                            <div className="cardss"><FaShoppingCart className="industry-icon" /> E-commerce</div>
                            <div className="cardss"><FaGraduationCap className="industry-icon" /> Education</div>
                            <div className="cardss"><FaBuilding className="industry-icon" /> Real Estate</div>
                        </div>
                    </div>
                </section>
                <section className="whyss">
                    <p className="subtitless">WHY CHOOSE US</p>
                    <h2 className="titless">
                        Why Choose Us for WhatsApp API & Chatbot
                    </h2>
                    <p>
                        Choosing the right associate for WhatsApp API & Chatbot implementation is crucial for success.
                        We provide end-to-give up answers tailor-made on your commercial enterprise requirements,
                        together with advanced <b className="bold">WhatsApp business chatbot</b> integration to automate
                        and
                        beautify your patron verbal exchange.
                    </p>

                    <div className="why-containerss">
                        <div className="center-imagess">
                            <img src={centerImage} alt="transport" />
                        </div>

                        <div className="left-cardsss">
                            <div className="cardsss left-card card1">
                                <span>Advanced Integration</span>
                            </div>
                            <div className="cardsss left-card card2">
                                <span>Smart Automation</span>
                            </div>
                        </div>

                        <div className="right-cards">
                            <div className="cardsss left-card card3">
                                <span>Custom Solutions</span>
                            </div>
                            <div className="cardsss right-card card4">
                                <span>Quick Deployment</span>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </section>
</>
);
};

export default WhatsAppApi;
